/* eslint-disable no-console */
/* eslint-disable newline-per-chained-call */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/sort-comp */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { getBackendBaseUrl, getReportsBaseUrl } from '../../constants';
import axiosInstance from '../../config/axios';
import { fetchInstData, getBackendId, instData } from '../../constants/apiEnv';

class SSDashboardEmbed extends Component {
  static domainPrefix = {
    'dev': 'dev.',
    'test': 'test.',
    'staging': 'staging.',
    'prod': ''
  }[process.env.REACT_APP_MAIN_PREFIX ? process.env.REACT_APP_MAIN_PREFIX.split('_')[1] : 'dev'];

  static async fetchSSGuestToken(dashId, backendId, appBasicAuth) {
    let resp = {};
    const baseURL = backendId ? `https://backend.${backendId}.${SSDashboardEmbed.domainPrefix}aerosimple.com/api` : getBackendBaseUrl() ? getBackendBaseUrl() : 'https://backend.app.aerosimple.com/api';
    const publicHost = process.env.REACT_APP_BACKEND_PUBLICHOST ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${backendId}.${SSDashboardEmbed.domainPrefix}aerosimple.com/public`;
    const url = appBasicAuth ? `${publicHost}/airport/ss_guest_token/${dashId}` : `${baseURL}/users/ss_guest_token?dashboards=${dashId}`;
    if (appBasicAuth) {
      await axiosInstance({
        method: 'get',
        headers: {
          Authorization: `Basic ${atob(appBasicAuth.replace('Basic ', '').split('').reverse('').join('').substring(1))}`
        },
        url
      }).then((response) => { resp = response.data; });
    } else {
      await axiosInstance({
        method: 'get',
        url
      }).then((response) => { resp = response.data; });
    }
    return resp.token;
  }

  static async embedDash(elementId, dashId, backendId, appBasicAuth, props = {}) {
    let thatDiv = document.getElementById(elementId);
    if (thatDiv) {
      embedDashboard({
        id: dashId.split('__')[0],
        supersetDomain: process.env.REACT_APP_REPORTS_URL ? process.env.REACT_APP_REPORTS_URL : backendId ? `https://reports.${backendId}.${SSDashboardEmbed.domainPrefix}aerosimple.com` : getReportsBaseUrl(),
        mountPoint: thatDiv,
        fetchGuestToken: () => SSDashboardEmbed.fetchSSGuestToken(dashId, backendId, appBasicAuth),
        dashboardUiConfig: {
            hideTitle: props.hideTitle !== undefined ? props.hideTitle : true,
            hideTab: props.showTab !== undefined ? !props.showTab : true,
            hideChartControls: props.hideChartControls !== undefined ? props.hideChartControls : true,
            filters: {
                expanded: props.filtersExpanded || false,
                visible: props.filtersHidden !== undefined ? !props.filtersHidden : !appBasicAuth
            }
        },
        iframeSandboxExtras: ['allow-top-navigation', 'allow-popups-to-escape-sandbox', 'allow-modals']
      });
      if (thatDiv.firstChild) {
        thatDiv.firstChild.style.height = 'inherit';
      }
    }
  }

  static dashboardIdFromUri(dashUri, backendId, user) {
    const reportsRaw = instData[backendId]?.reports || {};
    let report = reportsRaw[dashUri] || Object.values(reportsRaw).find(r => r?.dashboardId === dashUri);

    if (!report) {
      const baseKey = dashUri.split('__')[0];
      report = reportsRaw[baseKey];
    }

    if (!report || report.disabled || report.internal) {
      return null;
    }

    // Airport-level checks only when user context is available
    if (user?.airport?.code) {
      const airportCode = user.airport.code.toLowerCase();
      const codeSuffix = dashUri.split('__')[1]?.toLowerCase();

      if (codeSuffix && codeSuffix !== airportCode) {
        return null;
      }

      if (report.airportCodes
          && !report.airportCodes.split(',').map(a => a.toLowerCase()).includes(airportCode)) {
        return null;
      }

      if (report.excludedAirports?.length > 0
          && report.excludedAirports.includes(user.airport.code.toUpperCase())) {
        return null;
      }
    }

    return report.dashboardId;
  }

  componentDidMount = async () => {
    this.loadDashboard();
  };

  componentDidUpdate = (prevProps) => {
    const prevDashUri = prevProps?.match?.params?.dashUri;
    const currentDashUri = this.props?.match?.params?.dashUri;
    if (prevDashUri !== currentDashUri) {
      this.loadDashboard();
    }
  };

  loadDashboard = async () => {
    try {
      const { elementId, dashKey, match, user } = this.props;
      const key = dashKey || match?.params?.dashUri;
      const backendId = match?.params?.backendId || getBackendId();
      const appBasicAuth = match?.params?.auth;
      if (!appBasicAuth) {
        await fetchInstData(backendId);
      }
      let dashId = key.indexOf('-') > 1 ? key : SSDashboardEmbed.dashboardIdFromUri(key, backendId, user);
      if (dashId) {
        await SSDashboardEmbed.embedDash(elementId, dashId, backendId, appBasicAuth, this.props);
      }
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { elementId } = this.props;
    return (
      <div id={elementId} style={{ height: 'inherit', display: 'contents' }} />
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.profile
});

const mapDispatchToProps = () => ({
});

SSDashboardEmbed.defaultProps = {
  elementId: 'ssReportDashboard',
  dashKey: false,
  hideTitle: true,
  showTab: false,
  hideChartControls: true,
  filtersHidden: false,
  filtersExpanded: false
};

SSDashboardEmbed.propTypes = {
  elementId: PropTypes.string,
  dashKey: PropTypes.bool,
  hideTitle: PropTypes.bool,
  showTab: PropTypes.bool,
  hideChartControls: PropTypes.bool,
  filtersHidden: PropTypes.bool,
  filtersExpanded: PropTypes.bool,
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SSDashboardEmbed);
